module.exports = __webpack_public_path__ + "img/move.ac6babdf.png";